var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Breadcrumb',{attrs:{"breadcrumb":_vm.breadcrumb}}),_vm._v(" "),_c('b-container',[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('TextInfo',{attrs:{"content":_vm.cms,"isArray":Array.isArray(_vm.cms)}})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }